export default "__VITE_ASSET__CwTqlNsO__"